import {
	SaveDraftQuoteTHeadUser,
	SaveDraftTHeadAccount,
	SaveDraftTHeadDate,
	SaveDraftTHeadDesigner,
	SaveDraftTHeadDraft,
	SaveDraftTHeadOrderType,
	SaveDraftTHeadProductLine
} from "components/NewOrders/constants.ts";
import { HeadCell } from "components/Common/Table/SortableTableHead.tsx";

export const draftQuoteTableHeadCells = [
	{
		id: "updatedAt",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadDate,
		sortable: true
	},
	{
		id: "draft",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadDraft,
		sortable: false
	},
	{
		id: "account",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadAccount,
		sortable: false
	},
	{
		id: "user",
		numeric: false,
		disablePadding: false,
		label: SaveDraftQuoteTHeadUser,
		sortable: false
	},
	{
		id: "productLine",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadProductLine,
		sortable: false
	},
	{
		id: "draftOrderId",
		numeric: false,
		disablePadding: false,
		label: "Quote Number",
		sortable: false
	},
	{
		id: "empty",
		numeric: false,
		disablePadding: false,
		label: "",
		sortable: false
	}
];

export const draftTableHeadCells = [
	{
		id: "updatedAt",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadDate,
		sortable: true
	},
	{
		id: "draft",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadDraft,
		sortable: false
	},
	{
		id: "account",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadAccount,
		sortable: false
	},
	{
		id: "designer",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadDesigner,
		sortable: false
	},
	{
		id: "productLine",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadProductLine,
		sortable: false
	},
	{
		id: "orderType",
		numeric: false,
		disablePadding: false,
		label: SaveDraftTHeadOrderType,
		sortable: false
	},
	{
		id: "empty",
		numeric: false,
		disablePadding: false,
		label: "",
		sortable: false
	}
] as const satisfies readonly HeadCell[];
